// global getters


